import { Component } from '@angular/core';

@Component({
    selector: 'app-driver-sessions',
    templateUrl: './driver-sessions.component.html',
    styleUrls: ['./driver-sessions.component.css'],
    standalone: false
})
export class DriverSessionsComponent {
}
